import { DataTable, type Table } from "../table";
import type { CustomerReceivablesRow } from "./types";

export function ReceivablesCustomersTable({
  table,
  displayRows,
  onOpenCustomer,
}: {
  table: Table<CustomerReceivablesRow>;
  displayRows: CustomerReceivablesRow[];
  onOpenCustomer: (customerId: number) => void;
}) {
  return (
    <DataTable
      table={table}
      displayRows={displayRows}
      onRowClick={(row) => onOpenCustomer(row.customerId)}
    />
  );
}
